import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Editor, {
  TABLE_CELL_COMPONENT,
  FORM_FIELD_COMPONENT,
  NOT_APPLICABLE,
} from 'tuc-webui-base/components/editors/Editor';
import './TableDateEditor.scss';

//
// Render a license with a representative icon and the license ID
//
const TableDateComponent = ({ value }) => {
  if (!value) {
    return <div className="grb-table-date"><Typography variant="body2">N/A</Typography></div>;
  }
  const d = new Date(value);
  return (
    <div className="grb-table-date">
      <Typography variant="body2">{d.toLocaleDateString()}</Typography>
      <Typography variant="body2">{d.toLocaleTimeString()}</Typography>
    </div>
  );
};

TableDateComponent.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

TableDateComponent.defaultProps = {
  value: undefined,
};

export default class TableDateEditor extends Editor {
  constructor(name, components) {
    super(name || 'tableDate', Object.assign({}, {
      [TABLE_CELL_COMPONENT]: [TableDateComponent, TableDateComponent],
      [FORM_FIELD_COMPONENT]: [TableDateComponent],
    }, components));
  }

  formatValue(value) {
    if (value === undefined) return NOT_APPLICABLE;
    const d = new Date(value);
    return `${d.toLocaleDateString()} ${d.toLocaleTimeString()}`;
  }

  getSortValue(value /* ,formattedValue, props */) {
    if (!value) return 0;
    if (typeof value === 'string') {
      try {
        const d = new Date(value);
        return d.getTime();
      } catch (e) {
        return 0;
      }
    }
    return value;
  }
}
